<template>
  <div id="findPwd">
    <header class="header">
      <img src="../../assets/img/logo2.png" alt class="logo">
    </header>
    <section class="section">
      <div class="title">BRM系统账号绑定微信</div>
      <div id="pwdContent">
        <el-row>
          <el-col :span="4">
            <div :class="step>=1?'active':'num'">1</div>
            <div>
              <div class="f16 titleMain">填写账号</div>
              <div class="f14 c9">
                请填写要绑定的
                <br>系统账号
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div :class="step>=1?'lineActive':'line'"></div>
          </el-col>
          <el-col :span="4">
            <div :class="step>=2?'active':'num'">2</div>
            <div>
              <div class="f16 titleMain">验证手机</div>
              <div class="f14 c9">
                验证绑定的手机
                <br>号码是否有效
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div :class="step>=2?'lineActive':'line'"></div>
          </el-col>
          <el-col :span="4">
            <div :class="step>=3?'active':'num'">3</div>
            <div>
              <div class="f16 titleMain">绑定成功</div>
              <div class="f14 c9">
                已成功绑定手机
                <br>号码及微信
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="step">
          <el-form ref="form" label-width="80px">
            <customHint style="margin-left: 80px;width: 80%;margin-bottom: 13px" msg="用户名或密码错误" :ifHint="form.ifHint"/>
          </el-form>
          <!--填写z账号-->
          <el-form ref="form" :model="form" label-width="80px" v-show="step==1">
            <el-form-item label="用户名">
              <el-input v-model="form.name" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="密码">
              <el-input v-model="form.name" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item style="margin-top: 40px;">
              <el-button class="submit" @click="step==2">提交</el-button>
              <el-button>返回登录</el-button>
            </el-form-item>
          </el-form>
          <!--验证手机-->
          <el-form :model="form" label-width="80px" v-show="step==2">
            <el-form-item label="手机号：">
              <el-input v-model="form.code" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item label="验证码：">
              <el-input v-model="form.code" placeholder="请输入验证码" style="width: 199px;"></el-input>
              <el-button style="border:1px solid #c6c6c6;margin-left: 10px;">获取验证码</el-button>
            </el-form-item>
            <el-form-item class="step3Btn">
              <i class="el-icon-success" style="color:#3fb838;margin-right:10px;margin-top:6px;"></i>
              <div>
                验证码已发送到你的手机，5分钟内输入有效，
                <br>验证码等同于密码，打死也不能告诉别人！
              </div>
            </el-form-item>
            <el-form-item style="margin-top: 40px;margin-left: 68px">
              <el-button class="submit">提交</el-button>
              <el-button>上一步</el-button>
            </el-form-item>
          </el-form>

          <!--设置成功-->
          <div class="unBindPhone" v-show="step==3">
            <img src="../../assets/img/login/set_success.png" alt class="error">
            <div class="f18">设置成功</div>
            <div class="f12 c9">登录时请使用新密码</div>
            <el-button class="submit" style="margin-top:65px;" @click="toLogin">去登录</el-button>
          </div>
        </div>
      </div>
    </section>
    <div class="footerJS2">Copyright© 2019 杭州久点网络技术有限公司</div>
  </div>
</template>

<script>
  import customHint from "../../components/customHint/customHint";
  export default {
    data: function() {
      return {
        form: {
          name: "",
          show: false,
          code: "",
          pwd: "",
          againPwd: "",
          customColor: "#f5222d",
          ifHint: true
        },
        step: 2 //步骤
      };
    },
    computed: {
      stepfun: function() {
        return this.step+1;
      }
    },
    methods: {
      toLogin() {
        this.$router.push("/login");
      },
      oneStep() {
        this.stepfun;
      }
    },
    components: {
      customHint
    }
  };
</script>
<style scoped>
  @import "../../style/login.scss";
</style>
